<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Forms from "../../../mixins/Forms";

import axios from 'axios';

/**
 * WhatsApp profile component
 */
export default {
  page: {
    title: "WhatsApp Profile",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  mixins: [Forms],
  created() {
    this.loadWhatsappProfile();
  },
  data() {
    return {
      title: "WhatsApp Profile",
      items: [
        {
          text: "Profile",
          href: "#"
        },
        {
          text: "WhatsApp Profile",
          active: true
        }
      ],
      whatsappProfile: null,
      serverErrors: [],
      isLoading: false,
      isSendingTestMessage: false
    };
  },
  methods: {
    loadWhatsappProfile() {
      let vm = this;
      vm.whatsappProfile = null;
      vm.isLoading = true;
      axios.get(API_BASE + '/profile/whatsapp-profile').then(r => {
        vm.isLoading = false;
        vm.whatsappProfile = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    },
    sendTestMessage() {
      let vm = this;
      vm.isSendingTestMessage = true;
      vm.serverErrors = [];
      
      axios.post(API_BASE + '/profile/send-test-message').then(r => {
        vm.isSendingTestMessage = false;
        // Show success message or handle response
        console.log('Test message sent successfully');
      }).catch(e => {
        console.log(e);
        vm.isSendingTestMessage = false;
        
        // Handle different error response formats
        if (e.response && e.response.data && e.response.data.message) {
          vm.serverErrors = [e.response.data.message];
        } else {
          vm.setErrors(e);
        }
      });
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>
    <loading-screen :is-loading="isLoading"></loading-screen>
    <div class="row" v-if="whatsappProfile !== null">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h4 class="card-title mb-0">WhatsApp Profile Information</h4>
              <button 
                @click="loadWhatsappProfile" 
                class="btn btn-itg btn-md"
                :disabled="isLoading"
              >
                <i class="bx bx-sync me-1" :class="{ 'bx-spin': isLoading }"></i>
                Refresh
              </button>
            </div>
            <div class="form-group row">
              <label for="microsoftId" class="col-form-label col-lg-2">Microsoft ID</label>
              <div class="col-lg-10">
                <input 
                  type="text" 
                  class="form-control" 
                  id="microsoftId" 
                  :value="whatsappProfile.microsoft_id" 
                  disabled
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="teamsConversationId" class="col-form-label col-lg-2">Teams Conversation ID</label>
              <div class="col-lg-10">
                <input 
                  type="text" 
                  class="form-control" 
                  id="teamsConversationId" 
                  :value="whatsappProfile.teams_conversation_id" 
                  disabled
                />
                <div v-if="!whatsappProfile.teams_conversation_id" class="alert alert-warning mt-2" style="font-size: 0.95rem; font-weight: 500; padding: 0.75rem; border: 1px solid #ffc107; background-color: #fff3cd;">
                  <i class="bx bx-info-circle mr-2 d-inline-block"></i>
                  <strong>Not linked to your Teams.</strong> Please click on TESS in the sidebar in your Teams and send the bot a message to link.
                </div>
                <button 
              @click="sendTestMessage" 
              class="btn btn-itg-dark btn-md"
              :disabled="isSendingTestMessage || !(whatsappProfile && whatsappProfile.teams_conversation_id)"
            >
              <i class="bx bx-send me-2" v-if="!isSendingTestMessage"></i>
              <i class="bx bx-loader-circle me-2" v-if="isSendingTestMessage"></i>
              Send Test Message
            </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
 
  </Layout>
</template>

<style scoped>
</style>
